import { Domain } from '@shared/app/scripts/services/domain';
import { IConfig } from '@shared/app/scripts/services/config';

/*
 * Service posReasons
 */
angular
  .module('posApp')
  .factory(
    'posReasons',
    (
      $http: ng.IHttpService,
      $q: ng.IQService,
      domain: Domain,
      config: IConfig,
    ) => {
      const posReasons = {
        init: () => {
          return $http
            .get(
              '//' + domain.sibling(config.spynlSubdomain) + '/pos_reasons/get',
              {
                withCredentials: true,
              },
            )
            .then((response) => {
              if (
                !response.data ||
                !response.data.data ||
                response.data.data.length === 0
              ) {
                return $q.reject('Failed to load reasons');
              }

              const responseData = response.data.data[0];

              const discountReasons = responseData.DiscountReasons
                  ? responseData.DiscountReasons
                  : [],
                withdrawalReasons = responseData.WithdrawalTypes
                  ? responseData.WithdrawalTypes
                  : [],
                openDrawerReasons = responseData.OpenDrawerReasons
                  ? responseData.OpenDrawerReasons
                  : [];

              angular.copy(discountReasons, posReasons.discount);
              angular.copy(withdrawalReasons, posReasons.withdrawal);
              angular.copy(openDrawerReasons, posReasons.openDrawer);
            });
        },
        withdrawal: [],
        discount: [],
        openDrawer: [],
      };

      return posReasons;
    },
  );
